import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import delay from 'lodash/delay';
import { SLOW_TIMER } from '~/const/timers';
import CategoryFiltersBar from '~/components/templates/Category/CategoryFiltersBar.vue';
import CategoryFiltersList from '~/components/templates/Category/CategoryFiltersList.vue';
import CategorySortsLoading from '~/components/organisms/Category/Loading/CategorySortsLoading.vue';
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
import CategoryProductCount from '~/components/molecules/Category/CategoryProductCount.vue';
import CategorySorts from '~/components/organisms/Category/CategorySorts.vue';
import CategoryProductList from '~/components/organisms/Category/CategoryProductList.vue';
import CategoryStickyButtons from '~/components/organisms/Category/CategoryStickyButtons.vue';
import CategoryLayer from '~/components/organisms/Category/CategoryLayer.vue';
import CommercialBanner from '~/components/atoms/Global/CommercialBanner.vue';
import MdmInfiniteScroll from '~/components/atoms/Global/MdmInfiniteScroll.vue';
import MdmPagination from '~/components/atoms/Global/MdmPagination.vue';
var PRODUCTS_PER_PAGE = 40;
export default {
  name: 'CategoryTemplate',
  components: {
    CategoryFiltersBar: CategoryFiltersBar,
    CategoryFiltersList: CategoryFiltersList,
    CategorySortsLoading: CategorySortsLoading,
    CategoryProductCount: CategoryProductCount,
    CategoryProductListLoading: CategoryProductListLoading,
    CategorySorts: CategorySorts,
    CategoryProductList: CategoryProductList,
    CategoryStickyButtons: CategoryStickyButtons,
    CategoryLayer: CategoryLayer,
    CommercialBanner: CommercialBanner,
    MdmInfiniteScroll: MdmInfiniteScroll,
    MdmPagination: MdmPagination
  },
  props: {
    serverFetch: {
      type: Boolean,
      default: false
    },
    nextPage: {
      type: Number,
      required: true
    },
    loadingNextPage: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      default: false
    },
    previousPage: {
      type: Number,
      required: true
    },
    loadingPreviousPage: {
      type: Boolean,
      default: false
    },
    currentPath: {
      type: String,
      required: true
    },
    description: {
      type: Object,
      required: true
    },
    breadcrumb: {
      type: Array,
      required: true
    },
    productsCount: {
      type: Number,
      required: true
    },
    filters: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    selectedFilters: {
      type: Array,
      required: true
    },
    algolia: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedLayer: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    seeResultsLabel: function seeResultsLabel() {
      return "".concat(this.$t('see-results'), " (").concat(this.productsCount, ")");
    },
    paginationTracking: function paginationTracking() {
      return {
        data: {
          event_category: 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    infiniteFrom: function infiniteFrom() {
      return this.nextPage * PRODUCTS_PER_PAGE;
    },
    progressMsg: function progressMsg() {
      var x = this.infiniteFrom < this.productsCount ? this.infiniteFrom : this.productsCount;
      return this.$t('message', {
        x: x,
        y: this.productsCount
      });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.listenMatchMedia('DESKTOP', function () {
      delay(function () {
        _this.open = false;

        _this.enableWindowScroll();
      }, SLOW_TIMER);
    });
    this.bindScrollListener();
  },
  beforeDestroy: function beforeDestroy() {
    this.enableWindowScroll();
  },
  destroyed: function destroyed() {
    this.unbindScrollListener();
  },
  methods: _objectSpread({}, mapMutations({
    resetFilters: 'pageActions/RESET_FILTERS'
  }), {
    reset: function reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },
    bindScrollListener: function bindScrollListener() {
      window.addEventListener('scroll', this.handleScrollOnce, {
        once: true,
        passive: true
      });
    },
    unbindScrollListener: function unbindScrollListener() {
      window.removeEventListener('scroll', this.handleScrollOnce);
    },
    handleScrollOnce: function handleScrollOnce() {
      this.unbindScrollListener();
    },
    handleOpenLayer: function handleOpenLayer(layer) {
      this.disableWindowScroll();
      this.selectedLayer = layer;
    },
    handleCloseLayer: function handleCloseLayer() {
      this.enableWindowScroll();
      this.selectedLayer = null;
    },
    formatUrl: function formatUrl(url) {
      return url.replace(':market', this.locale.market).replace(':language', this.locale.language);
    }
  })
};